module.exports = __webpack_public_path__ + "img/组 94.aac1821c.png";